export const MAX_PODCAST_POSITIVE_FEEDBACK_COUNT = 3;

export const ReducerKeys = {
  LISTENERS: 'LISTENERS',
  SHOW_COUNT: 'showCount',
};
